/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { useTranslation } from 'react-i18next';
import { Icon } from './Icon';
import { Text } from './Text';
import { Title } from './Title';

const RebalanceOrBuyOrSellReused = () => {
  const { t } = useTranslation();

  return (
    <>
      <Icon type={'error'} />
      <Title>{t('NOTIFICATION_REBALANCE_OR_BUY_OR_SELL_REUSE_MODAL__title')}</Title>
      <Text>{t('NOTIFICATION_REBALANCE_OR_BUY_OR_SELL_REUSE_MODAL__desc')}</Text>
    </>
  );
};

export { RebalanceOrBuyOrSellReused };
